module.exports = __webpack_public_path__ + "static/media/restart.fd582799.svg";